import { render, staticRenderFns } from "./ImageWidget.vue?vue&type=template&id=2ba3009f&"
import script from "./ImageWidget.vue?vue&type=script&lang=js&"
export * from "./ImageWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/digital-seaside/sst-admin-panel/webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ba3009f')) {
      api.createRecord('2ba3009f', component.options)
    } else {
      api.reload('2ba3009f', component.options)
    }
    module.hot.accept("./ImageWidget.vue?vue&type=template&id=2ba3009f&", function () {
      api.rerender('2ba3009f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dynamic-list-items/widgets/ImageWidget.vue"
export default component.exports